// Loading.jsx
import React from 'react';
import Flag from 'react-world-flags';
import styles from './Loading.module.css';

const flags = ['us', 'gb', 'fr', 'de', 'es', 'it', 'ru', 'ua', 'jp', 'cn']; // ISO 3166-1 alpha-2

export default function Loading() {
  const radius = 100;

  return (
    <div className={styles.loadingContainer}>
      <div className={styles.spinner}>
        {flags.map((code, index) => {
          const angle = (360 / flags.length) * index;
          const x = radius * Math.cos((angle * Math.PI) / 180);
          const y = radius * Math.sin((angle * Math.PI) / 180);
          return (
            <div
              key={code}
              className={styles.flag}
              style={{ transform: `translate(${x}px, ${y}px)` }}
            >
              <Flag
                code={code}
                style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover' }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
